/**
 * Document files the widget can upload: a JPEG or PNG photo, or a PDF. The
 * backend's LivenessEntry serializer accepts the same three for `document`
 * and `document_back` (single-page PDFs), and the OCR provider reads PDFs.
 */
export const PDF_MIME = "application/pdf";

const ALLOWED_DOCUMENT_TYPES = ["image/jpeg", "image/jpg", "image/png", PDF_MIME];

/** What the file picker shows: photos and PDFs, nothing else. */
export const DOCUMENT_UPLOAD_ACCEPT = "image/jpeg,image/png,application/pdf,.pdf";

export function isPdf(file: Blob): boolean {
  return file.type === PDF_MIME;
}

export function isAllowedDocumentType(file: Blob): boolean {
  return ALLOWED_DOCUMENT_TYPES.includes(file.type);
}

/**
 * Some systems report a PDF with an empty type. Upload sends file.type as the
 * part's content type and the backend checks it, so give such a file the PDF
 * type from its .pdf name.
 */
export function withDocumentType(file: File): File {
  if (!file.type && /\.pdf$/i.test(file.name)) {
    return new File([file], file.name, { type: PDF_MIME });
  }
  return file;
}

/** Upload file name with the extension that matches what's inside. */
export function documentFileName(file: Blob, base: string): string {
  return `${base}.${isPdf(file) ? "pdf" : "jpg"}`;
}
